// extracted by mini-css-extract-plugin
export default {"signUp-container":"SignUp_signUp-container__s-L2T","input-container":"SignUp_input-container__S2oXr"};